import useApi from '../hook/useApi';

const useRoleApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const getRoles = async (forDropDown = false) => {
    return sendRequest(`/user/role?forDropDown=${forDropDown}`, 'GET', {});
  };

  return {
    getRoles,
    loading,
    data,
    error,
  };
};

export default useRoleApi;